import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useObservableAndState } from '@provider-portal/common/hooks/useObservableAndState';
import { useCommonAppServices } from '@provider-portal/common/services/ContextProviders';
import { EventProps } from '@provider-portal/common/services/MixpanelService';

import { BoltStarAnalyticsEvents } from './analyticsEvents';

interface BoltStarEventScreenAnalyticsContext {
  moduleName: string;
  screenName: string;
}

export function useTrackBoltStarEvent(screen?: BoltStarEventScreenAnalyticsContext) {
  const location = useLocation();
  const { mixpanelService, accountService } = useCommonAppServices();
  const { providerId } = useObservableAndState(accountService.getSelectedProviderData$());
  const { moduleName, screenName } = screen ?? {};

  return useCallback(
    (event: BoltStarAnalyticsEvents, props: EventProps = {}) => {
      if (!providerId) {
        return;
      }

      mixpanelService.trackProviderEvent(event, {
        providerId,
        currentUrl: location.pathname,
        ...(moduleName ? { currentModuleName: moduleName } : {}),
        ...(screenName ? { currentScreenName: screenName } : {}),
        ...props,
      });
    },
    [providerId, mixpanelService, location.pathname, moduleName, screenName],
  );
}
